import { render, staticRenderFns } from "./facebook-login-button.vue?vue&type=template&id=5c3a3112"
import script from "./facebook-login-button.vue?vue&type=script&lang=ts"
export * from "./facebook-login-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3a3112')) {
      api.createRecord('5c3a3112', component.options)
    } else {
      api.reload('5c3a3112', component.options)
    }
    module.hot.accept("./facebook-login-button.vue?vue&type=template&id=5c3a3112", function () {
      api.rerender('5c3a3112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/facebook-login-button.vue"
export default component.exports